// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"80":"c30ac7dd","149":"d98fcbcb","150":"80edd254","243":"b1bea68d","353":"7ea86c46","453":"42fc7d66","784":"b8b2326e","794":"2129b1e3","841":"6d2219fa","982":"8a6f58ed"}[chunkId] + ".chunk.js";
};